import { styled } from 'baseui'
import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { getQueryVariable } from '../../core/utils'
import ConfirmIcon from '../../components/ConfirmIcon'
import LoginCard from '../../components/LoginCard'


const SIGNIN_PAGE = '/accounts/signin';

const StyledText = styled('p', {
  fontSize: '18px',
  fontWeight: '600',
  lineHeight: '1.5',
  color: '#333',
})

async function generateCodeChallenge(verifier) {
  const encoder = new TextEncoder();
  const data = encoder.encode(verifier);
  const digest = await crypto.subtle.digest("SHA-256", data);
  return btoa(String.fromCharCode.apply(null, new Uint8Array(digest)))
    .replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

export function Confirm() {
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    const state_from = location.state?.from;
    try {
      const allowedPaths = ["/oauth/callback"];
      if (!allowedPaths.includes(state_from)) {
        navigate(SIGNIN_PAGE, { state: { error: 'access_denied_for_url' } });
      }
    } catch (e) {
      navigate(SIGNIN_PAGE, { state: { error: 'access_denied_for_url' } });
    }
  }, [navigate, location]);

  async function handleLogin() {
    const provider_url = process.env.REACT_APP_OAUTH_PROVIDER_URL
    const base_url = process.env.REACT_APP_BASE_URL
    const oauthAuthorizeUrl = `${provider_url}${process.env.REACT_APP_OAUTH_AUTHORIZE_URL}`
    const clientId = process.env.REACT_APP_OAUTH_CLIENT_ID
    const nextUrl = getQueryVariable('next')
    const redirectUri = `${base_url}${process.env.REACT_APP_REDIRECT_URL}?confirm=confirm&next=${nextUrl}`

    const codeVerifier = crypto.randomUUID();
    localStorage.setItem('pkce_code_verifier', codeVerifier);
    const codeChallenge = await generateCodeChallenge(codeVerifier);

    const params = new URLSearchParams({
      client_id: clientId,
      redirect_uri: redirectUri,
      response_type: "code",
      scope: "openid profile",
      code_challenge: codeChallenge,
      code_challenge_method: "S256"
    })

    window.location.href = `${oauthAuthorizeUrl}?${params.toString()}`
  }

  return (
    <LoginCard
      cardHeader={
        <>
          <ConfirmIcon />
          <StyledText>
            Contact에 등록된 계정이 없습니다.<br />그룹웨어 계정으로 서비스를 시작합니다.
          </StyledText>
        </>
      }
      onButtonClick={handleLogin}
      buttonText="확인"
      showLogo={false}
    >
    </LoginCard>
  )
}